import React from 'react';
import PropTypes from 'prop-types';
import SigninSignup from './signin-signup';
import { connect } from '../../util';

const UserRequiredComponent = (props) => {
  const WrappedComponent = props.component;
  if (!props.user.currentUser) {
    return <SigninSignup />;
  }
  return React.createElement(WrappedComponent, props);
};

UserRequiredComponent.propTypes = {
  component: PropTypes.func,
  user: PropTypes.shape({
    currentUser: PropTypes.object,
  }),
};

const mapStateToProps = (state, props) => ({
  user: state.user,
  app: state.app,
});

const userRequired = WrappedComponent => connect(
  UserRequiredComponent,
  { mapStateToProps },
  { component: WrappedComponent },
);

export default userRequired;



// WEBPACK FOOTER //
// ./src/containers/user/user-required.js